import TheGrid from '@/views/campaigns/bestof/campaignsapp/grid'
import Edit from '@/views/campaigns/bestof/campaignsapp/edit'

export default {
  path: '/campaigns/bestof/campaignsapp',
  redirect: '/campaigns/bestof/campaignsapp/index',
  name: 'campaignsapp',
  meta: {
    auth: {
      redirect: {
        name: 'campaignsapp.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Resultados'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'campaignsapp.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'campaignsapp.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'campaignsapp.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
